export class TemplateConstants {
  public static readonly DEFAULT_TEMPLATE = {
    description: null,
    name: null,
    projectTypeUuid: null,
    validTo: null,
  };

  public static readonly DEAL_KEY_DATE_TOOLTIP_TEXT =
    "Set the indicative date for this key date. This can be refined later as the deal develops.";
}
